import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Card, CardBody, Col, Row } from "reactstrap";
// Pages Components
import Miniwidget from "./Miniwidget";
//import MonthlyEarnings from "./montly-earnings";
import EmailSent from "./email-sent";
import MonthlyEarnings2 from "./montly-earnings2";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { Delete, MoreVert } from "@mui/icons-material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getItemPOList } from "../../api";
import { AmountCell } from "../../components/CustomComponents/AmountCell";
import useAuth from "../../hooks/useAuth";
import { getClientWithIdReq } from "../../service/clientService";
import { getPrFavoritesListReq, getPurchaseRequisitionListReq, removeFromFavouriteReq } from "../../service/purchaseRequisitionService";
import { getPurchaseOrderListReq } from "../../service/purchaseService";
import { MODULES_ENUM, PERMISSIONS_ENUM, USER_TYPES_ENUM } from "../../utility/constants";
import { formatDate } from "../../utility/formatDate";
import { formatNumberWithCommasAndDecimal } from "../Invoices/invoiceUtil";
import OrderStatusRenderer from "../Orders/OrderStatusRenderer";
import OrderGraph from "./order-graph";
import "./styles/Dashboard.scss";
// import AgreementPdfComponent from "./AgreementPdfComponent";

const Dashboard = (props) => {
  document.title = "Willsmeet Portal";
  let navigate = useNavigate();

  const breadcrumbItems = [{ title: "Dashboard", link: "#" }];

  const user = JSON.parse(localStorage.getItem("user"))
  const [inputValue, setInputValue] = useState('');
  const [rowData, setRowData] = useState([]);
  const [chipData, setChipData] = useState([
    {
      title: 'Total Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Total Purchase Orders',
      total: 0,
    },
    {
      title: 'Pending Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Pending Purchase Orders',
      total: 0,
    },
    {
      title: 'Approved Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Approved Purchase Orders',
      total: 0,
    },
  ]);
  const { auth } = useAuth();
  const [clientData, setClientData] = useState({});
  const [topItems, setTopItems] = useState([]);
  const [topItemsLoading, setTopItemsLoading] = useState(false);
  const [favourites, setFavourites] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);

  const toggleOptionsMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const handleDeleteFromFavorites = async (orderId) => {
    try {
      setOpenMenuId(null);
      const response = await removeFromFavouriteReq(orderId);

      if (response?.success === true) {
        setFavourites(prevFavourites =>
          prevFavourites.filter(item => item?.purchaseOrder?._id !== orderId)
        );
        notify('Success', "Removed from favorites");
      } else {
        notify('Error', 'Failed to remove from favorites');
      }
    } catch (error) {
      console.error("Error removing from favorites:", error);
      notify('Error', 'Failed to remove from favorites');
    }
  };

  const getDefaultYearDateRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    start.setHours(0, 0, 0, 0);

    const end = new Date(now);
    end.setHours(23, 59, 59, 999);

    return {
      start: start.toISOString(),
      end: end.toISOString(),
    };
  };


  const redirectToViewPage = (id) => {
    let path = `/purchase-orders/${id}`;
    setTimeout(() => {
      navigate(path, id);
    }, 300);
  };

  const handleViewClick = (id) => {
    redirectToViewPage(id.order_id);
  };

  const handleDeleteResponse = (response) => {
    if (response.success === true) {
      notify('Success', response.message);
    } else {
      notify('Error', response.message);
    }
    getPurchaseOrderListData();
  };

  const redirectToEditPage = (id) => {
    let path = `/purchase-orders/${id.order_id}/edit`;
    setTimeout(() => {
      navigate(path);
    }, 300);
  };

  const handleEditClick = (id) => {
    redirectToEditPage(id);
  };

  const notify = (type, message) => {
    if (type === 'Error') {
      toast.error(message, {
        position: 'top-center',
        theme: 'colored',
      });
    } else {
      toast.success(message, {
        position: 'top-center',
        theme: 'colored',
      });
    }
  };

  const getMonthName = (monthIndex) => {
    const months = [
      'January', 'February', 'March', 'April',
      'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'
    ];
    return months[monthIndex];
  }

  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  }

  const ordinalFormatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const monthName = getMonthName(date.getMonth());
    const ordinalDay = getOrdinal(date.getDate());

    return `${ordinalDay} ${monthName} ${year}`;
  };

  const getPurchaseOrderStatusList = async () => {
    try {
      const poList = await getPurchaseOrderListReq();
      const prList = await getPurchaseRequisitionListReq();

      const totalPR = prList.data.length;
      const approvedPR = prList.data.filter(pr => pr.PRStatus === "approved").length;
      const pendingPR = totalPR - approvedPR;

      const totalPO = poList.data.length;
      const approvedPO = poList.data.filter(po =>
        ["approved", "accepted"].includes(po.POStatus?.toLowerCase())
      ).length;

      const pendingPO = totalPO - approvedPO;

      setChipData([
        {
          title: 'Total Purchase Requisitions',
          total: totalPR,
          link: '/reports/customer-pr',
        },
        {
          title: 'Total Purchase Orders',
          total: totalPO,
          link: '/reports/customer-po',
        },
        {
          title: 'Pending Purchase Requisitions',
          total: pendingPR,
          link: '/reports/customer-pr?status=published',
        },
        {
          title: 'Pending Purchase Orders',
          total: pendingPO,
          link: '/reports/customer-po?status=published',
        },
        {
          title: 'Approved Purchase Requisitions',
          total: approvedPR,
          link: '/reports/customer-pr?status=approved',
        },
        {
          title: 'Approved Purchase Orders',
          total: approvedPO,
          link: '/reports/customer-po?status=approved',
        },
      ]);

    } catch (error) {
      console.error("Error:", error);
    }
  };


  const searchClient = async (id) => {
    try {
      const data = { _id: id };
      const res = await getClientWithIdReq(data);

      setClientData(res.payload?.client);
    } catch (error) {
      console.log(error);
    }
  };

  const getorders = async () => {
    const items = await getPurchaseRequisitionListReq()
  }

  const getPrFavoritesList = async () => {
    try {
      const response = await getPrFavoritesListReq()

      const uniqueFavourites = Array.from(
        new Map(response.data.map(item => [item?.purchaseOrder?._id, item])).values()
      )

      setFavourites(uniqueFavourites)
    } catch (error) {
      console.error("Error fetching favourites:", error)
      setFavourites([])
    }
  }

  useEffect(() => {
    getorders()
    getPrFavoritesList()
  }, [])

  const getPurchaseOrderListData = async () => {
    try {
      const response = await getPurchaseOrderListReq();

      if (!response || !response.data || !Array.isArray(response.data)) {
        console.error('Unexpected response format:', response);
        return;
      }
      const newData = response.data.map((order) => ({
        order_id: order._id,
        order_number: order.purchaseOrderNumber ? order.purchaseOrderNumber : '-',
        createdAt: formatDate(order.createdAt),

        total: Array.isArray(order.items)
          ? order.items.reduce(
            (total, item) => total + (item.unitPrice || 0) * (item.quantity || 0),
            0
          )
          : 0,

        order_status: order.POStatus || order.status,
        branch_name: order?.shipping?.branchName || '-'
      }));

      setRowData(newData.slice(-5));
    } catch (error) {
      console.error('Error fetching purchase orders:', error);
    }
  };

  const getTopItemsByAmount = async () => {
    try {
      setTopItemsLoading(true);

      const dateRange = getDefaultYearDateRange();

      const body = {
        page: 1,
        limit: 1000000,
        sortOrder: 'desc',
        sortBy: 'grandTotal',
        clientId: user?.userType === 'client' ? user?.clientId : '',
        startDate: dateRange.start,
        endDate: dateRange.end,
      };

      const res = await getItemPOList(body);

      if (res?.success && Array.isArray(res.payload?.data)) {
        const sorted = [...res.payload.data].sort(
          (a, b) => Number(b.grandTotal || 0) - Number(a.grandTotal || 0)
        );
        setTopItems(sorted.slice(0, 5));
      } else {
        setTopItems([]);
      }
    } catch (error) {
      console.error('Error fetching top items:', error);
      setTopItems([]);
    } finally {
      setTopItemsLoading(false);
    }
  };

  const handleCopyOrder = async (id) => {
    try {
      navigate(`/purchase-requisitions/${id}/copy`);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    props.setBreadcrumbItems('Dashboard', breadcrumbItems)
    getPurchaseOrderListData();
    getPurchaseOrderStatusList();
    searchClient(user.clientId)
    getTopItemsByAmount();
  }, [user.clientId]);

  return (
    <React.Fragment>

      <Row className="g-4 align-items-stretch">

        <Col xl="7" lg="7" md="12" className="d-flex">
          <div style={{ flex: 1, display: "flex" }}>
            <Miniwidget reports={chipData} style={{ flex: 1, height: "auto" }} />
          </div>
        </Col>

        <Col xl="5" lg="5" md="12" className="d-flex">
          <Card style={{ flex: 1, height: "auto" }}>
            <CardBody className="h-100 d-flex flex-column">
              <h5 className="mb-3">Top 5 Items</h5>

              {
                topItemsLoading ? (
                  <div>Loading...</div>
                ) : topItems.length === 0 ? (
                  <div>No data available</div>
                ) : (
                  <table className="top-items-table w-100">
                    <tbody>
                      {topItems.map((item) => (
                        <tr key={item.itemId}>
                          <td>{item.itemName || "-"}</td>
                          <td style={{ textAlign: "right" }}>
                            <AmountCell value={item.grandTotal} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              }
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xl="12">
          <Card>
            <CardBody>
              <OrderGraph />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="g-4 align-items-stretch">

        <Col xl="6" md="12" className="d-flex">
          <Card className="w-100 h-100">
            <CardBody className="d-flex flex-column h-100">
              <h4 className="mb-4">Recent Orders</h4>

              {rowData.length === 0 ? (
                <div>No recent orders</div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="w-100" style={{ minWidth: "700px" }}>

                    {/* HEADER */}
                    <thead>
                      <tr style={{ fontSize: "13px", color: "#6B6B6B" }}>
                        <th>Order</th>
                        <th>Branch</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th style={{ textAlign: "right" }}>Amount</th>
                      </tr>
                    </thead>

                    {/* BODY */}
                    <tbody>
                      {rowData.map((item) => (
                        <tr
                          key={item.order_id}
                          style={{
                            borderTop: "1px solid #eee",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate(`/purchase-orders/${item.order_id}`)
                          }
                        >
                          <td style={{ padding: "10px 0", fontWeight: 500 }}>
                            {item.order_number}
                          </td>

                          <td>{item.branch_name}</td>

                          <td>{item.createdAt}</td>

                          <td>
                            <OrderStatusRenderer value={item.order_status} />
                          </td>

                          <td style={{ textAlign: "right" }}>
                            <AmountCell value={item.total} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>

        <Col xl="6" md="12" className="d-flex">
          <Card className="w-100 h-100">
            <CardBody className="d-flex flex-column h-100">
              <h4 className="mb-3">Favourite Orders</h4>

              {favourites.length === 0 ? (
                <div>No favourite orders yet</div>
              ) : (
                <table className="top-items-table w-100">
                  <thead>
                    <tr style={{ fontSize: "14px", color: "#000" }}>
                      <th style={{ textAlign: "left", paddingBottom: "8px" }}>
                        PR No.
                      </th>
                      <th style={{ textAlign: "center", paddingBottom: "8px" }}>
                        Total Amount
                      </th>
                      <th style={{ textAlign: "right", paddingBottom: "8px" }}>
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {favourites.map((item) => (
                      <tr key={item.id} style={{ cursor: "default" }}>
                        <td
                          onClick={() => handleCopyOrder(item?.purchaseOrder?._id)}
                          style={{ cursor: "pointer", color: "#0d6efd", textDecoration: "underline" }}
                        >
                          {item?.purchaseOrder?.purchaseRequisitionNumber || "--"}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          <AmountCell value={item?.purchaseOrder?.grandTotal} />
                        </td>

                        <td style={{ textAlign: "right", position: "relative" }}>
                          <div
                            onClick={() => toggleOptionsMenu(item?.purchaseOrder?._id)}
                            style={{ cursor: "pointer", display: "inline-block" }}
                          >
                            <MoreVert />
                          </div>

                          {openMenuId === item?.purchaseOrder?._id && (
                            <>
                              <div
                                className="menu-backdrop"
                                onClick={() => toggleOptionsMenu(null)}
                              />

                              <div className="options-menu">
                                <div
                                  className="options-menu-item"
                                  onClick={() => handleCopyOrder(item?.purchaseOrder?._id)}
                                >
                                  Copy
                                </div>
                                <div
                                  className="options-menu-item delete"
                                  onClick={() => handleDeleteFromFavorites(item?.purchaseOrder?._id)}
                                >
                                  Delete
                                </div>
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </CardBody>
          </Card>
        </Col>

      </Row>

    </React.Fragment>
  );
}

export default connect(null, { setBreadcrumbItems })(Dashboard);
